// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/leftLoginImage.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/icons/rightLoginImage.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------Parent container & background Blur------------------------- */

.Homepage_parentContainer__FVxrR {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100dvh;
    overflow-x: hidden;
    position: relative;
}

.Homepage_backgroundBlur__0ktAn{
    position: absolute;
    /* overflow: hidden; */
    width: 100vw;
    /* height: 100vh; */
    top: 0;
    left: 0;
    background: linear-gradient(to right, #fdfdfd, #fdfdfd);
    display: flex;
    flex-grow: 1;
    z-index: -1;
}
.Homepage_backgroundBlur__0ktAn div {
    position: absolute;
    border-radius: 100%;
    height: 0;
    filter: blur(200px);
    opacity: .4;
}
.Homepage_backgroundBlur__0ktAn div:nth-child(1) {
    background: linear-gradient(132deg, #FF9A01 0%, #FF9A01 100%);
    width: 15%;
    padding-top: 70%;
    left: 5%;
    top: 70%;
    transform: translate(-50%) translateY(-50%);
}
.Homepage_backgroundBlur__0ktAn div:nth-child(2) {
    background: linear-gradient(132deg, #D75EFD 0%, #D75EFD 100%);
    width: 17%;
    padding-top: 68%;
    left: 100% !important;
    top: -40% !important;
    transform: translate(-80%) translateY(20%);
    rotate: 90deg;
}
.Homepage_backgroundBlur__0ktAn div:nth-child(3) {
    background: linear-gradient(132deg, #60ECBA 0%, #60ECBA 100%);
    width: 25%;
    padding-top: 70%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%) translateY(20%);
}




/* -------------------------------Left Container ---------------------------------------- */

.Homepage_leftContainer__cpXlU{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: calc(100vh - 100px);
    max-height: 725px !important;
}


.Homepage_d_flex__Gp-Tx{
    display: flex;
}

.Homepage_lighting_strike__kMudm{
    width: 30px;
    height: 60px;
    margin-right: 8px;
}

.Homepage_LightningText__2wBhN {
    font-size: 20px;
    margin-bottom: 10px;
    margin-top: 0;
    line-height: 20px;
    color: #817E7E;
}

.Homepage_TradingNInvesting__-9DvS {
    font-size: 24px;
    color: #4f4f4f;
    font-weight: bolder;
    line-height: 20px;
    margin-top: 0;
    
}

.Homepage_StocksText__1YIUx {
    color: #f05156;
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.Homepage_fadeOut__IiYF2 {
    opacity: 0;
    transform: translateY(0);
}

.Homepage_fadeIn__6QPv0 {
    opacity: 1;
    transform: translateY(-20px);
}

.Homepage_animate__lPQ6D {
    animation: Homepage_fadeOut__IiYF2 0.5s ease-in-out forwards, Homepage_fadeIn__6QPv0 0.5s ease-in-out forwards 0.5s;
}

@keyframes Homepage_fadeOut__IiYF2 {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(0);
    }
}

@keyframes Homepage_fadeIn__6QPv0 {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}










/* ----------------------Right Container----------------------------- */
.Homepage_rightContainer__f74BM {
    width: 450px;
    height: calc(100vh - 100px);
    max-height: 646px !important;
    border-radius: 20px;
    box-shadow: 0 0 15px 3px #817e7e1a;
    background-color: #fff !important;
    min-height: 550px;
    position: relative;
    display: flex;
    flex-direction: column; 
}

.Homepage_applicationContainer__EmFxA{
    display: flex;
    gap:15px;
    margin-top: 30px;
}

.Homepage_newUser__pnjwv, .Homepage_existingUser__0BjEf{
    background-color: #f8767a44;
    color: #000000;
    padding: 5px 10px;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.5s ease-in-out;

}
.Homepage_newUser__pnjwv:hover, .Homepage_existingUser__0BjEf:hover{
    box-shadow: 0 5px 20px #d2d2d2fa;
}

.Homepage_selectedUser__gLG9M{
    background-color: #f8767a;
color: #fff;
padding: 5px 10px;
border-radius: 24px;
cursor: pointer;
transition: all 0.5s ease-in-out;
}

.Homepage_registerContent__ECcl4::before{
    position: absolute;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    left: -300px;
    top: 0;
    z-index: -1;
}
.Homepage_registerContent__ECcl4{
    margin: 0 55px 5px;
    position: relative;
    height: 100%;
}

.Homepage_registerContent__ECcl4::after {
    position: absolute;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    right: -250px;
    bottom: 0;
    z-index: -1;
    overflow: hidden;

}
.Homepage_registerLog__\\+3A1G{
    margin-top: 78px;
    /* height: 30%; */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.Homepage_rightLogo__2hznt {
    width: 20%;
    margin: 0 auto;
}

.Homepage_createAccountText__7no2G {
    font-family: 'CircularXXWeb', sans-serif;
    font-weight: 700;
    color: #4f4f4f;
    margin-top: 30px; 
    text-align: center;
    /* margin-top: -50px; */
    margin-bottom: 60px;
}

.Homepage_emailOTPText__CMzEc{
    /* text-align: center; */
    /* max-width: 70%; */
    word-break: break-all;
}

.Homepage_form__input_group__G\\+XvU {
    margin: 15px 0;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
}

.Homepage_form__input__8nyXY {
    width: 100%;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    transition: border 0.25s ease-in-out;
    height: 50px !important;
    color: #4f4f4f !important;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
}
.Homepage_form__input__8nyXY:focus {
    border: 1px solid #e4e4e4;
    outline: none;
}
.Homepage_mobileprefix__qw5Au{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-40%,-50%);
}

.Homepage_form__input_label__OGMqn {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    transition: all 0.25s ease-in-out;
    font-size: 14px;
}

.Homepage_form__input_label__OGMqn {
    top: 0;
    background-color: #ffffff;
    font-size: 12px;
    padding: 0 5px;
    color: #777;
    font-weight: 400;
}
.Homepage_errorText__iXAe2{
    font-size: 12px;
    line-height: 18px;
    color: #dd6565;
    margin-left: 5px;
}
.Homepage_checkBoxContainer__-T9-s{
    font-size: 12px;
    padding-left: 5px;
}
.Homepage_Button__DMViA{
    background-image: linear-gradient(to top, #f73439, #f8777b) !important;
    margin-top: .8rem !important;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    line-height: 1.13;
    color: #fff;
    height: 44px;
    border-radius: 8px !important;
    border: none;
    cursor: pointer;
}

.Homepage_Button__DMViA:disabled {
    background-image: none !important;
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
}

@media (max-width: 1150px) {
    .Homepage_leftContainer__cpXlU{
        display: none;
    }

    .Homepage_rightContainer__f74BM {
        margin: 0 20px;
    }

}
@media (max-width: 440px) {
    .Homepage_registerContent__ECcl4{
        margin: 20px;
    }

}


/* ------------------------------Stepper ---------------------------------- */
.Homepage_stepperContainer__\\+QXQf {
    width: 100%;
    padding: 20px 0;
    margin-top: -50px;
  }
  
  .Homepage_stepperWrapper__NZkzZ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
  
  .Homepage_stepperWrapper__NZkzZ::before {
    content: '';
    position: absolute;
    top: 30%;
    left: 25%;
    width: 50%;
    height: 2px;
    background: #e4e4e4;
    transform: translateY(-50%);
    z-index: 1;
  }
  
  .Homepage_stepperItem__Pvvp8 {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1;
    z-index: 2;
  }
  
  .Homepage_stepCounter__a7FNW {
    position: relative;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #e4e4e4;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    margin-bottom: 6px;
    transition: all 0.3s ease-in-out;
  }
  
  .Homepage_stepName__oXWZt {
    font-size: 14px;
    color: #817E7E;
    transition: all 0.3s ease-in-out;
  }
  
  .Homepage_stepperItem__Pvvp8.Homepage_active__zmpXG .Homepage_stepCounter__a7FNW {
    border-color: #f05156;
    color: #f05156;
  }
  
  .Homepage_stepperItem__Pvvp8.Homepage_active__zmpXG .Homepage_stepName__oXWZt {
    color: #f05156;
  }
  
  .Homepage_stepperItem__Pvvp8.Homepage_completed__9eEfi .Homepage_stepCounter__a7FNW {
    background-color: #f05156;
    border-color: #f05156;
    color: #fff;
  }
  
  .Homepage_stepperItem__Pvvp8.Homepage_completed__9eEfi .Homepage_stepName__oXWZt {
    color: #4f4f4f;
  }
  
  /* Add a line between steps that updates with progress */
  .Homepage_stepperItem__Pvvp8.Homepage_completed__9eEfi::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 2px;
    background-color: #f05156;
    top: 15px;
    left: 50%;
    z-index: -1;
  }
  
  /* Adjust the line for the last item */
  .Homepage_stepperItem__Pvvp8:last-child::after {
    display: none;
  }


/* ------------------------------- OTP Component-------------------------- */
.Homepage_OTPTextContainer__91q9X{
    display: flex;
    align-items: center;
    gap: 10px;
    
}

.Homepage_OTPTextContainer__91q9X h4{
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    line-height: 1.13;
    color: #404040bf;
}

.Homepage_OTPIcon__pXdF7{
    cursor: pointer;
}

.Homepage_otpInput__lrNGA {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 0.3rem;
    text-align: center;
    font-size: 1.2rem;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
    color: #4f4f4f;
    margin-top: -20px;
    -moz-appearance: textfield;
}
.Homepage_otpInput__lrNGA::-webkit-outer-spin-button,
.Homepage_otpInput__lrNGA::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.Homepage_otpInput__lrNGA:focus {
    border-color: #f05156;
    outline: none;
    box-shadow: 0 0 0 2px rgba(240, 81, 86, 0.1);
}

/* .otpInput:hover {
    border-color: #f05156;
} */

.Homepage_resendContainer__Wd0r6 {
  margin: 15px 0;
}

.Homepage_timerText__onpe9 {
  color: #4f4f4f;
  font-size: 14px;
}

.Homepage_timerText__onpe9 span {
  color: #f05156;
  font-weight: 600;
}

.Homepage_resendText__eSLsq {
  font-size: 14px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.Homepage_resendText__eSLsq.Homepage_enabled__jRHiU {
  color: #f05156;
  cursor: pointer;
  font-weight: 500;
}

.Homepage_resendText__eSLsq.Homepage_enabled__jRHiU:hover {
  opacity: 0.8;
}

.Homepage_resendText__eSLsq.Homepage_disabled__3Ys2k {
  color: #817E7E;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/components/Homepage.module.css"],"names":[],"mappings":"AAAA,wFAAwF;;AAExF;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,uDAAuD;IACvD,aAAa;IACb,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,6DAA6D;IAC7D,UAAU;IACV,gBAAgB;IAChB,QAAQ;IACR,QAAQ;IACR,2CAA2C;AAC/C;AACA;IACI,6DAA6D;IAC7D,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;IAC1C,aAAa;AACjB;AACA;IACI,6DAA6D;IAC7D,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,0CAA0C;AAC9C;;;;;AAKA,2FAA2F;;AAE3F;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;;AAEjB;;AAEA;IACI,cAAc;IACd,gEAAgE;AACpE;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,mHAAmF;AACvF;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;;;;;;;;;AAWA,uEAAuE;AACvE;IACI,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,kCAAkC;IAClC,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;;AAEpC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B,WAAW;AACX,iBAAiB;AACjB,mBAAmB;AACnB,eAAe;AACf,gCAAgC;AAChC;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,YAAY;IACZ,MAAM;IACN,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gDAAiD;IACjD,aAAa;IACb,SAAS;IACT,WAAW;IACX,gBAAgB;;AAEpB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,sEAAsE;IACtE,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;AAEJ;AACA;IACI;QACI,YAAY;IAChB;;AAEJ;;;AAGA,6EAA6E;AAC7E;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA,wDAAwD;EACxD;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,SAAS;IACT,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;;AAGF,4EAA4E;AAC5E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;IACd,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,4CAA4C;AAChD;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/* ------------------------Parent container & background Blur------------------------- */\n\n.parentContainer {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 100dvh;\n    overflow-x: hidden;\n    position: relative;\n}\n\n.backgroundBlur{\n    position: absolute;\n    /* overflow: hidden; */\n    width: 100vw;\n    /* height: 100vh; */\n    top: 0;\n    left: 0;\n    background: linear-gradient(to right, #fdfdfd, #fdfdfd);\n    display: flex;\n    flex-grow: 1;\n    z-index: -1;\n}\n.backgroundBlur div {\n    position: absolute;\n    border-radius: 100%;\n    height: 0;\n    filter: blur(200px);\n    opacity: .4;\n}\n.backgroundBlur div:nth-child(1) {\n    background: linear-gradient(132deg, #FF9A01 0%, #FF9A01 100%);\n    width: 15%;\n    padding-top: 70%;\n    left: 5%;\n    top: 70%;\n    transform: translate(-50%) translateY(-50%);\n}\n.backgroundBlur div:nth-child(2) {\n    background: linear-gradient(132deg, #D75EFD 0%, #D75EFD 100%);\n    width: 17%;\n    padding-top: 68%;\n    left: 100% !important;\n    top: -40% !important;\n    transform: translate(-80%) translateY(20%);\n    rotate: 90deg;\n}\n.backgroundBlur div:nth-child(3) {\n    background: linear-gradient(132deg, #60ECBA 0%, #60ECBA 100%);\n    width: 25%;\n    padding-top: 70%;\n    left: 50%;\n    bottom: 5%;\n    transform: translate(-50%) translateY(20%);\n}\n\n\n\n\n/* -------------------------------Left Container ---------------------------------------- */\n\n.leftContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    height: calc(100vh - 100px);\n    max-height: 725px !important;\n}\n\n\n.d_flex{\n    display: flex;\n}\n\n.lighting_strike{\n    width: 30px;\n    height: 60px;\n    margin-right: 8px;\n}\n\n.LightningText {\n    font-size: 20px;\n    margin-bottom: 10px;\n    margin-top: 0;\n    line-height: 20px;\n    color: #817E7E;\n}\n\n.TradingNInvesting {\n    font-size: 24px;\n    color: #4f4f4f;\n    font-weight: bolder;\n    line-height: 20px;\n    margin-top: 0;\n    \n}\n\n.StocksText {\n    color: #f05156;\n    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;\n}\n\n.fadeOut {\n    opacity: 0;\n    transform: translateY(0);\n}\n\n.fadeIn {\n    opacity: 1;\n    transform: translateY(-20px);\n}\n\n.animate {\n    animation: fadeOut 0.5s ease-in-out forwards, fadeIn 0.5s ease-in-out forwards 0.5s;\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n\n\n\n\n\n\n\n\n/* ----------------------Right Container----------------------------- */\n.rightContainer {\n    width: 450px;\n    height: calc(100vh - 100px);\n    max-height: 646px !important;\n    border-radius: 20px;\n    box-shadow: 0 0 15px 3px #817e7e1a;\n    background-color: #fff !important;\n    min-height: 550px;\n    position: relative;\n    display: flex;\n    flex-direction: column; \n}\n\n.applicationContainer{\n    display: flex;\n    gap:15px;\n    margin-top: 30px;\n}\n\n.newUser, .existingUser{\n    background-color: #f8767a44;\n    color: #000000;\n    padding: 5px 10px;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: all 0.5s ease-in-out;\n\n}\n.newUser:hover, .existingUser:hover{\n    box-shadow: 0 5px 20px #d2d2d2fa;\n}\n\n.selectedUser{\n    background-color: #f8767a;\ncolor: #fff;\npadding: 5px 10px;\nborder-radius: 24px;\ncursor: pointer;\ntransition: all 0.5s ease-in-out;\n}\n\n.registerContent::before{\n    position: absolute;\n    content: url(../assets/icons/leftLoginImage.svg);\n    left: -300px;\n    top: 0;\n    z-index: -1;\n}\n.registerContent{\n    margin: 0 55px 5px;\n    position: relative;\n    height: 100%;\n}\n\n.registerContent::after {\n    position: absolute;\n    content: url(../assets/icons/rightLoginImage.svg);\n    right: -250px;\n    bottom: 0;\n    z-index: -1;\n    overflow: hidden;\n\n}\n.registerLog{\n    margin-top: 78px;\n    /* height: 30%; */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.rightLogo {\n    width: 20%;\n    margin: 0 auto;\n}\n\n.createAccountText {\n    font-family: 'CircularXXWeb', sans-serif;\n    font-weight: 700;\n    color: #4f4f4f;\n    margin-top: 30px; \n    text-align: center;\n    /* margin-top: -50px; */\n    margin-bottom: 60px;\n}\n\n.emailOTPText{\n    /* text-align: center; */\n    /* max-width: 70%; */\n    word-break: break-all;\n}\n\n.form__input_group {\n    margin: 15px 0;\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n}\n\n.form__input {\n    width: 100%;\n    border: 1px solid #e4e4e4;\n    border-radius: 8px;\n    transition: border 0.25s ease-in-out;\n    height: 50px !important;\n    color: #4f4f4f !important;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 400;\n}\n.form__input:focus {\n    border: 1px solid #e4e4e4;\n    outline: none;\n}\n.mobileprefix{\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translate(-40%,-50%);\n}\n\n.form__input_label {\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    transform: translateY(-50%);\n    transition: all 0.25s ease-in-out;\n    font-size: 14px;\n}\n\n.form__input_label {\n    top: 0;\n    background-color: #ffffff;\n    font-size: 12px;\n    padding: 0 5px;\n    color: #777;\n    font-weight: 400;\n}\n.errorText{\n    font-size: 12px;\n    line-height: 18px;\n    color: #dd6565;\n    margin-left: 5px;\n}\n.checkBoxContainer{\n    font-size: 12px;\n    padding-left: 5px;\n}\n.Button{\n    background-image: linear-gradient(to top, #f73439, #f8777b) !important;\n    margin-top: .8rem !important;\n    width: 100%;\n    font-size: 16px;\n    font-weight: 400;\n    font-stretch: normal;\n    line-height: 1.13;\n    color: #fff;\n    height: 44px;\n    border-radius: 8px !important;\n    border: none;\n    cursor: pointer;\n}\n\n.Button:disabled {\n    background-image: none !important;\n    background-color: #ccc;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n@media (max-width: 1150px) {\n    .leftContainer{\n        display: none;\n    }\n\n    .rightContainer {\n        margin: 0 20px;\n    }\n\n}\n@media (max-width: 440px) {\n    .registerContent{\n        margin: 20px;\n    }\n\n}\n\n\n/* ------------------------------Stepper ---------------------------------- */\n.stepperContainer {\n    width: 100%;\n    padding: 20px 0;\n    margin-top: -50px;\n  }\n  \n  .stepperWrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n  }\n  \n  .stepperWrapper::before {\n    content: '';\n    position: absolute;\n    top: 30%;\n    left: 25%;\n    width: 50%;\n    height: 2px;\n    background: #e4e4e4;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n  \n  .stepperItem {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n    z-index: 2;\n  }\n  \n  .stepCounter {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: #fff;\n    border: 2px solid #e4e4e4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    margin-bottom: 6px;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .stepName {\n    font-size: 14px;\n    color: #817E7E;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .stepperItem.active .stepCounter {\n    border-color: #f05156;\n    color: #f05156;\n  }\n  \n  .stepperItem.active .stepName {\n    color: #f05156;\n  }\n  \n  .stepperItem.completed .stepCounter {\n    background-color: #f05156;\n    border-color: #f05156;\n    color: #fff;\n  }\n  \n  .stepperItem.completed .stepName {\n    color: #4f4f4f;\n  }\n  \n  /* Add a line between steps that updates with progress */\n  .stepperItem.completed::after {\n    position: absolute;\n    content: '';\n    width: 100%;\n    height: 2px;\n    background-color: #f05156;\n    top: 15px;\n    left: 50%;\n    z-index: -1;\n  }\n  \n  /* Adjust the line for the last item */\n  .stepperItem:last-child::after {\n    display: none;\n  }\n\n\n/* ------------------------------- OTP Component-------------------------- */\n.OTPTextContainer{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    \n}\n\n.OTPTextContainer h4{\n    font-size: 16px;\n    font-weight: 500;\n    font-stretch: normal;\n    line-height: 1.13;\n    color: #404040bf;\n}\n\n.OTPIcon{\n    cursor: pointer;\n}\n\n.otpInput {\n    width: 2.5rem;\n    height: 2.5rem;\n    margin: 0 0.3rem;\n    text-align: center;\n    font-size: 1.2rem;\n    border: 1px solid #e4e4e4;\n    border-radius: 8px;\n    transition: all 0.2s ease-in-out;\n    color: #4f4f4f;\n    margin-top: -20px;\n    -moz-appearance: textfield;\n}\n.otpInput::-webkit-outer-spin-button,\n.otpInput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.otpInput:focus {\n    border-color: #f05156;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(240, 81, 86, 0.1);\n}\n\n/* .otpInput:hover {\n    border-color: #f05156;\n} */\n\n.resendContainer {\n  margin: 15px 0;\n}\n\n.timerText {\n  color: #4f4f4f;\n  font-size: 14px;\n}\n\n.timerText span {\n  color: #f05156;\n  font-weight: 600;\n}\n\n.resendText {\n  font-size: 14px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.resendText.enabled {\n  color: #f05156;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.resendText.enabled:hover {\n  opacity: 0.8;\n}\n\n.resendText.disabled {\n  color: #817E7E;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parentContainer": `Homepage_parentContainer__FVxrR`,
	"backgroundBlur": `Homepage_backgroundBlur__0ktAn`,
	"leftContainer": `Homepage_leftContainer__cpXlU`,
	"d_flex": `Homepage_d_flex__Gp-Tx`,
	"lighting_strike": `Homepage_lighting_strike__kMudm`,
	"LightningText": `Homepage_LightningText__2wBhN`,
	"TradingNInvesting": `Homepage_TradingNInvesting__-9DvS`,
	"StocksText": `Homepage_StocksText__1YIUx`,
	"fadeOut": `Homepage_fadeOut__IiYF2`,
	"fadeIn": `Homepage_fadeIn__6QPv0`,
	"animate": `Homepage_animate__lPQ6D`,
	"rightContainer": `Homepage_rightContainer__f74BM`,
	"applicationContainer": `Homepage_applicationContainer__EmFxA`,
	"newUser": `Homepage_newUser__pnjwv`,
	"existingUser": `Homepage_existingUser__0BjEf`,
	"selectedUser": `Homepage_selectedUser__gLG9M`,
	"registerContent": `Homepage_registerContent__ECcl4`,
	"registerLog": `Homepage_registerLog__+3A1G`,
	"rightLogo": `Homepage_rightLogo__2hznt`,
	"createAccountText": `Homepage_createAccountText__7no2G`,
	"emailOTPText": `Homepage_emailOTPText__CMzEc`,
	"form__input_group": `Homepage_form__input_group__G+XvU`,
	"form__input": `Homepage_form__input__8nyXY`,
	"mobileprefix": `Homepage_mobileprefix__qw5Au`,
	"form__input_label": `Homepage_form__input_label__OGMqn`,
	"errorText": `Homepage_errorText__iXAe2`,
	"checkBoxContainer": `Homepage_checkBoxContainer__-T9-s`,
	"Button": `Homepage_Button__DMViA`,
	"stepperContainer": `Homepage_stepperContainer__+QXQf`,
	"stepperWrapper": `Homepage_stepperWrapper__NZkzZ`,
	"stepperItem": `Homepage_stepperItem__Pvvp8`,
	"stepCounter": `Homepage_stepCounter__a7FNW`,
	"stepName": `Homepage_stepName__oXWZt`,
	"active": `Homepage_active__zmpXG`,
	"completed": `Homepage_completed__9eEfi`,
	"OTPTextContainer": `Homepage_OTPTextContainer__91q9X`,
	"OTPIcon": `Homepage_OTPIcon__pXdF7`,
	"otpInput": `Homepage_otpInput__lrNGA`,
	"resendContainer": `Homepage_resendContainer__Wd0r6`,
	"timerText": `Homepage_timerText__onpe9`,
	"resendText": `Homepage_resendText__eSLsq`,
	"enabled": `Homepage_enabled__jRHiU`,
	"disabled": `Homepage_disabled__3Ys2k`
};
export default ___CSS_LOADER_EXPORT___;
